<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{
      caixaAlta(limitar(formulario.nome, 30))
    }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Especialidade</strong></td>
            <td>{{ formulario.especialidade.nome }}</td>
          </tr>
          <tr>
            <td><strong>Avaliação</strong></td>
            <td
              :class="formulario.avaliacao ? 'text-success' : 'text-danger'"
              >{{ formulario.avaliacao ? 'Sim' : 'Não' }}</td
            >
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="formulario.ativo ? 'text-success' : 'text-danger'">{{
              formulario.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-1"
          :to="'/evolucao/formulario/cadastro/' + formulario._id"
          role="button"
          class="btn btn-sm btn-default"
          ><span class="fa fa-edit" /> Editar</RouterLink
        >
        <div class="btn-group" role="group">
          <button
            data-test-id="button-duplicar-2"
            type="button"
            class="btn btn-sm btn-default"
            @click="duplicar()"
          >
            <span class="fa fa-copy" /> Duplicar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'FormularioFicha',
  mixins: [alertaMixin],
  props: {
    formulario: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    duplicar() {
      this.$emit('duplicar', this.formulario)
    },
  },
}
</script>
